import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=cc4c6b84&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4c6b84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc4c6b84')) {
      api.createRecord('cc4c6b84', component.options)
    } else {
      api.reload('cc4c6b84', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=cc4c6b84&scoped=true&", function () {
      api.rerender('cc4c6b84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lEcC2vEBvGyG/JS/comp/Accordion.vue"
export default component.exports